import React from "react"
import PropTypes from "prop-types"
import { Button, ButtonGroup } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import BusinessLink from "../../fragments/BusinessLink"
import BatchLoans from "./BatchLoans"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import RenderBucket from "./RenderBucket"
import { CardType, fillingZeroUtility } from "../../../lib/utils"
import OtherCostsTable from "../OtherCostsTable"
import CreatedOnDate from "../../fragments/CreatedOnDate"
import ItemSummary from "../ItemSummary"
import RepaymentSummary from "../Buckets/RepaymentSummary"

class FinancierBatchCard extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    shouldChangeStatus: false,
    shouldDelete: false,
    running: false,
    success: false,
    error: null,
  }

  handleChangeStatus = () => this.setState({
    shouldChangeStatus: true,
    running: false,
    success: false,
    error: null,
  })

  handleDelete = () => this.setState({ 
    shouldDelete: true,
    running: false,
    success: false,
    error: null
  })

  confirmChangeStatus = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { financierBatch: { id: batchId, closed }, setFinancierBatch } = this.props

    blockingFetchService(
      accessToken => apiServerApi.changeStatusFinancierBatch(accessToken, batchId, !closed),
      resp => {
        this.setState({ success: true })
        setTimeout(() => {
          this.closeStatusForm()
          setFinancierBatch(batchId, resp)
        }, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { financierBatch: { id: batchId }, removeFinancierBatch, cardType } = this.props

    blockingFetchService(
      accessToken => apiServerApi.deleteFinancierBatch(accessToken, batchId),
      _ => {

        this.setState({ success: true })
        setTimeout(() => { 
          this.closeDeleteForm()
          removeFinancierBatch(batchId)
          if (cardType === CardType.LARGE) {
            browserHistory.push('/financiers/batches')
          }
        }, 800)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeStatusForm = () => this.setState({ shouldChangeStatus: false })

  closeDeleteForm = () => this.setState({ shouldDelete: false })

  renderUpdateContent = () => {

    const { financierBatch: { closed } } = this.props,
    { running, success, error } = this.state
    return (
      <div>
        <h3>{ closed ? 'Open' : 'Close' } this batch?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Are you sure you want to delete this batch?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderBtnGroup = (id, closed, nbLoans, isLarge) => (
    <ButtonGroup justified>

      <Button href="#" bsStyle="info" title={ closed ? 'Open' : 'Close'}
        onClick={ this.handleChangeStatus } disabled={ closed && !this.isAdmin }>
        <FontAwesome name={ closed ? 'eye' : 'eye-slash' } /> { closed ? 'Open' : 'Close' }
      </Button>

      <Button href="#" bsStyle="success" disabled={ !this.isAdmin }
        onClick={() => browserHistory.push(`/financiers/batches/${id}/update`)}>
        <FontAwesome name='pencil' /> Update
      </Button>

      <Button href="#" bsStyle="warning" disabled={ !this.isAdmin || nbLoans > 0 }
        onClick={ this.handleDelete } title={ nbLoans ? 'Unlink all loans first' : 'Delete' }>
        <FontAwesome name='trash-o' /> Delete
      </Button>

      { isLarge &&
      <Button href="#"
        onClick={() => browserHistory.push('/financiers/batches/create')}>
        <FontAwesome name='plus-circle' /> New Batch
      </Button>}
    </ButtonGroup>
  )

  showItem = () => {

    const { financierBatch, setFinancierBatch, reloadFinancierBatch, cardType, buckets,
      allUpfrontPayment, allTotalRepayment, runningRepaymentSummary } = this.props,

    { id, name, closed, nbLoans, loans, sellingCost, purchaseCost, createdOn, margin, otherCosts,
      financierBucket, affiliation, commissionFee, transportFee, currencyCode } = financierBatch,

    { id: affiliationId, name: affiliationName, businessId } = affiliation,

    isLarge = cardType === CardType.LARGE

    return (
      <div className='detail-content'>

        { this.renderBtnGroup(id, closed, nbLoans, isLarge) }

        <h2 className={ `${closed ? 'red' : 'blue'} mt-20` }>
          { name } { closed ? <small className="red">(closed)</small> : '' }
        </h2>

        <SimpleCardRow name='Affiliation' value={ !!affiliationId &&
          <BusinessLink id={ affiliationId } name={ affiliationName } businessId={ businessId } /> }
        />

        <SimpleCardRow name='Closed' value={ closed ? 'Yes' : 'No' } />

        <SimpleCardRow name='Currency code' value={ currencyCode ? currencyCode : '-' } />

        <SimpleCardRow name='Nb loans' value={ fillingZeroUtility(nbLoans) } />

        <RenderBucket
          batchId={ id }
          bucket={ financierBucket }
          reloadFinancierBatch={ reloadFinancierBatch }
          buckets={ buckets }
          closed={ closed }
        />

        <BatchLoans
          loans={ loans }
          batchId={ id }
          setFinancierBatch={ setFinancierBatch }
          isLarge={ isLarge }
          closed={ closed }
        />

        <RepaymentSummary
          allUpfrontPayment={ allUpfrontPayment }
          allTotalRepayment={ allTotalRepayment }
          running={ runningRepaymentSummary }
        />

        <OtherCostsTable
          commissionFee={ commissionFee }
          transportFee={ transportFee }
        />

        <ItemSummary
          purchaseCost={ purchaseCost }
          sellingCost={ sellingCost }
          otherCosts={ otherCosts }
          balance={ null }
          margin={ margin }
          isLarge={ isLarge }
        />

        <hr/>
        <CreatedOnDate createdOn={ createdOn } />
      </div>
    )
  }

  renderLargeCard = () => {

    const dataBreadCrumbs = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/batches', title: 'Batches' }
    ],

    { financierBatch: { name } } = this.props

    return (
      <div>
        <CustomBreadCrumb activeText={ name } data={ dataBreadCrumbs } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="folder-open" size="3x" className="detail-icon" />
          </Col>

          <Col md={8}>
            { this.showItem() }
          </Col>
        </Row>
      </div>
    )
  }

  render() {

    const { cardType } = this.props,

    { shouldChangeStatus, shouldDelete, running } = this.state

    return (
      <div>

        { cardType === CardType.SMALL ? this.showItem() : this.renderLargeCard() }

        <AlertModal
          show={ shouldChangeStatus }
          title="Confirm update"
          body={ this.renderUpdateContent() }
          bsStyle="danger"
          close={ this.closeStatusForm }
          confirm={ this.confirmChangeStatus }
          proceedText="Proceed"
          disabled={ running }
        />

        <AlertModal
          show={ shouldDelete }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

FinancierBatchCard.propTypes = {
  financierBatch: PropTypes.object.isRequired,
  cardType: PropTypes.string.isRequired,
}

export default FinancierBatchCard



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/Card.js